import arrowLeft from '~/assets/icons/arrow_left.svg';
import { playSound, Sound } from '~/assets/sounds';
import { StyledBackButton } from './AppBackButton.styled';

const AppBackButton = ({ onClick }: { onClick: () => void }) => {
	return (
		<StyledBackButton
			onClick={() => {
				onClick();
				playSound(Sound.ClickButton);
			}}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
		>
			<img src={arrowLeft} alt="arrowLeft" />
		</StyledBackButton>
	);
};

export { AppBackButton };
